var exports = {
  "vv": "x1cb7f6e3--f8a78c--phone-wrapper",
  "Lg": "x1cb7f6e3--f8a78c--qr-code-button",
  "SJ": "x1cb7f6e3--f8a78c--qr-code-icon",
};

module.exports = exports;
